import React, { useState, useEffect, lazy, Suspense } from 'react';
import CommonErrorPage from './CommonErrorPage'
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import AppServiceHealth from './AppServiceHealth';
import { MsalProvider, MsalAuthenticationTemplate, useMsal, useAccount } from "@azure/msal-react";
import { InteractionRequiredAuthError, InteractionType } from "@azure/msal-browser";
import AppService from 'Global/AppService';
import { NavHeader } from 'NavigationBar/NavHeader';
import LoaderComponent from 'Common/components/LoaderComponent';
import { PlaceHolderLoader } from 'Common/components/commonComponents';
import { connect } from 'react-redux';

import { appRedirect } from 'Global/UserAccessToken';
import ErrorComponent from 'Common/components/ErrorComponent';
import Footer from 'Global/Footer';
import { useIdleTimer } from 'react-idle-timer';
import { logout } from './AuthService';
import { LogoutComponent } from './LogoutComponent';
import { UnAuthorizedCompoent } from 'ErrorPages/UnAuthorizedComponent';
import { ROUTE_DASHBOARD_PATH, ROUTE_FILES_PATH, ROUTE_HOME ,ROUTE_METRICS,ROUTE_RSU,ROUTE_ADMIN,ROUTE_METER, ROUTE_DASHBOARD, ROUTE_WATCHLIST,ROUTE_USER_SERACH_HISTORY,ROUTE_TRIGGERS_PATH,ROUTE_TRIGGERS, ROUTE_SITE_VIEW, ROUTE_SITE_VIEW_PATH, ROUTE_FILES, ROUTE_ISE_CAL_REPORTS_PATH, ROUTE_CHEM_CAL_REPORTS_PATH, ROUTE_RB_REPORT_PATH, ROUTE_RSU_SOFTWARE_LIST,ROUTE_RSU_UPLOAD, FEATURES, ROUTE_PIPETTOR_MATCH_REPORT_PATH, ROUTE_PIPETTOR_MATCH_REPORT_SIMPLE_PATH, ROUTE_CARRYOVER_REPORT_PATH, ROUTE_CARRYOVER_REPORT_SIMPLE_PATH, ROUTE_LOWVOLUME_REPORT_PATH, ROUTE_LOWVOLUME_REPORT_SIMPLE_PATH, ROUTE_SYSTEM_CHECK_REPORT_PATH, ROUTE_SYSTEM_CHECK_REPORT_SIMPLE_PATH, ROUTE_RM_REPORT_SIMPLE_PATH, ROUTE_RM_ALL_WAVELENGTHS_SIMPLE_PATH, ROUTE_RULE_LIST, ROUTE_RULE_LIST_PATH } from 'Common/constants/commonConstants';

const HomepageComponent        = lazy(() => import('Home/components/HomepageComponent'));
const WatchlistComponent       = lazy(() => import('Watchlist/components/WatchlistComponent.js'));
const UserSearchHistory        = lazy(() => import('UserSearchHistory/components/UserSearchHistory'));
const RSUMODComponent          = lazy(() => import('RSUModule/components/RSUMODComponent'));
const AdminPageComponent       = lazy(() => import('Admin/components/AdminPageComponent'));
const MetricpageComponent      = lazy(() => import('Metrics/components/MetricpageComponent'));
const MeteringComponent        = lazy(() => import('Metering/components/MeteringComponent'));
const DashboardComponent       = lazy(() => import('Instrument/components/DashboardComponent'));
const FileUploadComponent      = lazy(() => import('FileUpload/components/FileUploadComponent'));
const SiteViewComponent        = lazy(() => import('SiteView/components/SiteViewComponent'));
const TriggerPanelComponent    = lazy(() => import('Triggers/Components/TriggerPanelComponent.js'));
const ISECalibrationComponent  = lazy(() => import('Instrument/subfeatures/ISECalibration/ISECalibrationComponent.js'));
const LegacyCalReportComponent = lazy(() => import('Instrument/subfeatures/Calibration/LegacyCalReportComponent.js'));

import * as TabsConstants from 'Tabs/TabsConstants';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { fetchApplicationVersion } from 'ECD/Version/FetchVersionAction';
import { fetchAllowedFeatures } from 'ECD/allowed-features/allowedFeaturesAction';
import { loadBannerMessages } from 'Admin/subfeatures/Banner/BannerAction';
import { getRolesForUserInvoke } from 'Admin/store/AdminPageAction';
import { getAllowedFeaturesUrl, getBannerMessageUrl, getRolesForUserUrl, getPrimaryInstanceIdUrl } from "ECD/NGIApiUrls";
import ErrorPage from 'Global/ErrorPage';
import { isFeatureEnabled } from 'Common/utils/Utils.js';
import PrivateRoute from 'Common/components/PrivateRoute.js';
import { AxiosService } from 'Common/services/AxiosService.js';
const RBReportComponent          = lazy(() => import('Instrument/subfeatures/ReagentBlank/ReagentBlankReport/RBReportComponent.js'));
const PipettorMatchReport        = lazy(() => import('Instrument/subfeatures/DiagnosticsData/PipettorMatch/PipettorMatchReport.js'));
const CarryOverReport            = lazy(() => import('Instrument/subfeatures/DiagnosticsData/CarryOver/CarryOverReport.js'));
const LowVolumeReport            = lazy(() => import('Instrument/subfeatures/DiagnosticsData/LowVolume/LowVolumeReport.js'));
const SystemCheckReport          = lazy(() => import('Instrument/subfeatures/DiagnosticsData/SystemCheck/SystemCheckReport.js'));
const ChemCalReportComponent     = lazy(() => import('Instrument/subfeatures/ChemCalibration/ChemCalReportComponent'));
const RMReport                   = lazy(() => import('Instrument/subfeatures/ReactionMonitor/RMReport.js'));
const RMAllWavelengths           = lazy(() => import('Instrument/subfeatures/ReactionMonitor/RMAllWavelengths.js'));
const RSUSoftwareListComponent   = lazy(() => import('RSUModule/subfeatures/software-list/RSUSoftwareListComponent'));
const RSUSoftwareUploadComponent = lazy(() => import('RSUModule/subfeatures/software-upload/RSUSoftwareUploadComponent'));
const RulesListComponent         = lazy(() => import('Instrument/subfeatures/TriggerRules/RulesComponent.js'));

const GetGlobalRouter = ({ versionNumberReducer, bannerData, featuresData }) => {

	const [userState, setUserState] = useState('validating');

	const dispatch = useDispatch();
	const location = useLocation();

	const primaryInstanceRoutes = [ROUTE_DASHBOARD, ROUTE_SITE_VIEW, ROUTE_FILES, ROUTE_RULE_LIST];
	const requiresPrimaryInstance = primaryInstanceRoutes.some(route => location.pathname.startsWith(route));
	const instanceId = requiresPrimaryInstance ? location.pathname.split("/")[2] : undefined;

	const [showUnAuthorized, setShowUnAuthorized] = useState(false);

	const [primaryInstanceId, setPrimaryInstanceId] = useState(undefined);
	// Initialize to true when on an instrument route so isAppLoading never drops
	// between auth completing and the fetchPrimaryInstance effect firing.
	const [instrumentLoading, setInstrumentLoading] = useState(!!instanceId);

	const getPrimaryInstanceId = async (instanceId) => {
		const { url, inputHeader } = getPrimaryInstanceIdUrl(instanceId);
		const response = await AxiosService.getData(url, inputHeader);
		if(response?.status === 403) {
			setShowUnAuthorized(true);
		}
		return response?.result?.primaryinstanceid;
	}

	useEffect(() => {
		const fetchPrimaryInstance = async () => {
			if(instanceId) {
				setPrimaryInstanceId(undefined);
				setInstrumentLoading(true);
				// Preload the DashboardComponent chunk now so Suspense
				// never shows its own fallback spinner.
				import('Instrument/components/DashboardComponent');
				const id = await getPrimaryInstanceId(instanceId);
				setPrimaryInstanceId(id);
				// Dashboard route keeps instrumentLoading=true until DashboardComponent
				// calls onReady(). All other instrument routes (SiteView, Files, etc.)
				// release immediately — their Suspense fallback handles chunk loading.
				if (!id || !location.pathname.startsWith(ROUTE_DASHBOARD)) {
					setInstrumentLoading(false);
				}
			} else {
				setInstrumentLoading(false);
			}
		};
		fetchPrimaryInstance();
	}, [instanceId]);

	const setLogintToStorage = (response, error) => {
		if (error.status === 403) {
			setUserState('unauthorized');
		} else {
			setUserState('authorized');
			localStorage.setItem("setUserLogin", 'true');
		}
	};

	const checkIfLoginSet = async () => {
		let loginCheck = localStorage.getItem("setUserLogin");
		if (!loginCheck) {
			await AppService.postData({}, process.env.APP_SERVICE + "/auditlogin", setLogintToStorage);
		}
		else {
			setUserState('authorized'); 
		}
	};


	useEffect(() => {
		const initializeApp = async () => {
			try {
				dispatch(fetchAllowedFeatures(getAllowedFeaturesUrl().url));
				await checkIfLoginSet();
				dispatch(fetchApplicationVersion(process.env.APP_SERVICE + "/deviceManagement/version"));
				dispatch(getRolesForUserInvoke(getRolesForUserUrl().url));
				dispatch(loadBannerMessages(getBannerMessageUrl().url));
			} catch (error) {
				console.error('Error initializing app:', error);
			}
		};
		initializeApp();
	}, []);
  
  	const handleIdleTimeout = event => {
		console.log("Starting auto logout. User as last active at ", new Date(getLastActiveTime()));
		logout(() => {
			appRedirect();
		}, {});
	};

	const { getLastActiveTime } = useIdleTimer({
		timeout: 1000 * process.env.IDLE_TIMEOUT_IN_SECONDS, //multiplied by 1000 to convert to ms
		onIdle: handleIdleTimeout,
		debounce: 500,
		crossTab: true
	});

	// Gate on MSAL token only — features (allowedFeatures) load in the background.
	// isAppLoading stays true across both auth phase AND instrument loading phase
	// so the spinner never flashes off between them.
	const isGateLoading = userState === 'validating';
	const isAppLoading  = isGateLoading || (requiresPrimaryInstance && instrumentLoading);

	if (userState == 'validating') {
		return (
			<>
				<LoaderComponent show={isAppLoading} />
				<Routes>
					<Route path="/Error" element={<CommonErrorPage/>}/>
					<Route path="/unauthorized" element={<UnAuthorizedCompoent/>}/>
				</Routes>
			</>
		)
	}
	else if (userState == 'authorized') {
		return (
			<>
				<LoaderComponent show={isAppLoading} />
				<Routes>
					<Route path="/Error" element={<CommonErrorPage/>}/>
					<Route path="/unauthorized" element={<UnAuthorizedCompoent/>}/>
					<Route path="/health" element={<AppServiceHealth/>}/>
					<Route path="/*" element={<>
						<ErrorPage>
							{bannerData.marqueeBannerFlag==true &&
							<marquee width="100%" direction="left" height="24px" style={{ color: "red", lineHeight: "24px" }}>
								{bannerData?.bannerMessageDisplay}
							</marquee>
							}
							<NavHeader></NavHeader>
							<div>
								<div>
									<div className="tab-content">
										<Routes>
											<Route path={ROUTE_HOME} element={
												<div id={`uncontrolled-tab-example-tabpane-${TabsConstants.TAB_NAME_HOME}`} className="fade tab-pane active show">
												<Suspense fallback={<LoaderComponent show={true} />}><HomepageComponent /></Suspense>
												</div>
											}/>
											<Route path={ROUTE_WATCHLIST} element={
												<div id={`uncontrolled-tab-example-tabpane-${TabsConstants.TAB_NAME_WATCHLIST}`} className="fade tab-pane active show">
													<Suspense fallback={<LoaderComponent show={true} />}><WatchlistComponent /></Suspense>
												</div>
											}/>
											<Route path={ROUTE_USER_SERACH_HISTORY} element={
												<div id={`uncontrolled-tab-example-tabpane-${TabsConstants.TAB_NAME_USER_SEARCH_HISTORY}`} className="fade tab-pane active show">
													<Suspense fallback={<LoaderComponent show={true} />}><UserSearchHistory /></Suspense>
												</div>
											}/>
												<Route path={ROUTE_SITE_VIEW_PATH} element={<>
													{ primaryInstanceId && (
													<div id={`uncontrolled-tab-example-tabpane-${TabsConstants.TAB_TITLE_SITE_VIEW + primaryInstanceId}`} className="fade tab-pane active show">
														<Suspense fallback={<LoaderComponent show={true} />}><SiteViewComponent instanceId={primaryInstanceId} tabName={TabsConstants.TAB_TITLE_SITE_VIEW + instanceId} activeTab={TabsConstants.TAB_TITLE_SITE_VIEW + primaryInstanceId} /></Suspense>
													</div>
													)}
												</>}/>
											<Route path={ROUTE_RSU} element={<PrivateRoute canActivate={isFeatureEnabled(featuresData.allowedFeatures,TabsConstants.TAB_NAME_RSU_DASHBOARD)} isLoading={featuresData.isAllowedFeaturesFetching}>
												<div id={`uncontrolled-tab-example-tabpane-${TabsConstants.TAB_NAME_RSU}`} className="fade tab-pane active show">
													<Suspense fallback={<LoaderComponent show={true} />}><RSUMODComponent /></Suspense>
												</div>
											</PrivateRoute>}/>
											<Route path={ROUTE_RSU_SOFTWARE_LIST} element={<PrivateRoute canActivate={isFeatureEnabled(featuresData.allowedFeatures,FEATURES.RSU_SW_VIEW)} isLoading={featuresData.isAllowedFeaturesFetching}>
												<div id={`uncontrolled-tab-example-tabpane-sub1-${TabsConstants.TAB_NAME_RSU}`} className="fade tab-pane active show">
													<Suspense fallback={<LoaderComponent show={true} />}><RSUSoftwareListComponent /></Suspense>
												</div>
											</PrivateRoute>}/>
											<Route path={ROUTE_RSU_UPLOAD} element={<PrivateRoute canActivate={isFeatureEnabled(featuresData.allowedFeatures,FEATURES.RSU_SW_UPLOAD)} isLoading={featuresData.isAllowedFeaturesFetching}>
												<div id={`uncontrolled-tab-example-tabpane-sub2-${TabsConstants.TAB_NAME_RSU}`} className="fade tab-pane active show">
													<Suspense fallback={<LoaderComponent show={true} />}><RSUSoftwareUploadComponent /></Suspense>
												</div>
											</PrivateRoute>}/>
											<Route path={ROUTE_METRICS} element={<PrivateRoute canActivate={isFeatureEnabled(featuresData.allowedFeatures,TabsConstants.TAB_NAME_METRICS_DASHBOARD)} isLoading={featuresData.isAllowedFeaturesFetching}>
												<div id={`uncontrolled-tab-example-tabpane-${TabsConstants.TAB_NAME_METRICS}`} className="fade tab-pane active show">
													<Suspense fallback={<LoaderComponent show={true} />}><MetricpageComponent /></Suspense>
												</div>
											</PrivateRoute>}/>
											<Route path={ROUTE_ADMIN} element={<PrivateRoute canActivate={isFeatureEnabled(featuresData.allowedFeatures,TabsConstants.TAB_NAME_ADMIN)} isLoading={featuresData.isAllowedFeaturesFetching}>
												<div id={`uncontrolled-tab-example-tabpane-${TabsConstants.TAB_NAME_ADMIN}`} className="fade tab-pane active show">
													<Suspense fallback={<LoaderComponent show={true} />}><AdminPageComponent /></Suspense>
												</div>
											</PrivateRoute>}/>
											<Route path={ROUTE_METER} element={<PrivateRoute canActivate={isFeatureEnabled(featuresData.allowedFeatures,TabsConstants.TAB_NAME_METERING)} isLoading={featuresData.isAllowedFeaturesFetching}>
												<div id={`uncontrolled-tab-example-tabpane-${TabsConstants.TAB_NAME_METERING}`} className="fade tab-pane active show">
													<Suspense fallback={<LoaderComponent show={true} />}><MeteringComponent /></Suspense>
												</div>
											</PrivateRoute>}/>
											<Route path={ROUTE_TRIGGERS} element={<PrivateRoute canActivate={isFeatureEnabled(featuresData.allowedFeatures,TabsConstants.TAB_NAME_CREATE_TRIGGERS)} isLoading={featuresData.isAllowedFeaturesFetching}>
												<div id={`uncontrolled-tab-example-tabpane-${TabsConstants.TAB_NAME_CREATE_TRIGGERS}`} className="fade tab-pane active show">
													<Suspense fallback={<LoaderComponent show={true} />}><TriggerPanelComponent /></Suspense>
												</div>
											</PrivateRoute>}/>
											<Route path={ROUTE_TRIGGERS_PATH} element={<PrivateRoute canActivate={isFeatureEnabled(featuresData.allowedFeatures,TabsConstants.TAB_NAME_CREATE_TRIGGERS)} isLoading={featuresData.isAllowedFeaturesFetching}>
												<div id={`uncontrolled-tab-example-tabpane-path-${TabsConstants.TAB_NAME_CREATE_TRIGGERS}`} className="fade tab-pane active show">
													<Suspense fallback={<LoaderComponent show={true} />}><TriggerPanelComponent /></Suspense>
												</div>
											</PrivateRoute>}/>
											<Route exact path={ROUTE_DASHBOARD_PATH} element={<>

												{ primaryInstanceId && (
												<div id={`uncontrolled-tab-example-tabpane-${TabsConstants.TAB_TITLE_INSTANCE + primaryInstanceId}`} className="fade tab-pane active show">
													<Suspense fallback={null}><DashboardComponent key={primaryInstanceId} instanceId={primaryInstanceId} tabName={TabsConstants.TAB_TITLE_INSTANCE + instanceId} activeTab={TabsConstants.TAB_TITLE_INSTANCE + primaryInstanceId} onReady={() => setInstrumentLoading(false)}/></Suspense>
													</div>
													)}
												</>}/>
												<Route exact path={ROUTE_FILES_PATH} element={<>
													{ primaryInstanceId && (
													<div id={`uncontrolled-tab-example-tabpane-${TabsConstants.TAB_TITLE_FILE_ACCESS + primaryInstanceId}`} className="fade tab-pane active show">
														<Suspense fallback={null}><FileUploadComponent fileAccessID={primaryInstanceId} tabName={TabsConstants.TAB_TITLE_FILE_ACCESS + instanceId} activeTab={TabsConstants.TAB_TITLE_FILE_ACCESS + primaryInstanceId} /></Suspense>
													</div>
													)}
												</>}/>
											<Route exact path={ROUTE_RULE_LIST_PATH} element={<>
                        						{ primaryInstanceId && (
												<div id={`uncontrolled-tab-example-tabpane-${TabsConstants.TAB_NAME_RULES + primaryInstanceId}`} className="fade tab-pane active show">
													<Suspense fallback={<LoaderComponent show={true} />}><RulesListComponent instanceId={primaryInstanceId} tabName={TabsConstants.TAB_NAME_RULES + instanceId} activeTab={TabsConstants.TAB_NAME_RULES + primaryInstanceId} /></Suspense>
												</div>
                        						)}
											</>}/>
											<Route path={"/consumer"} element={
												<div id={`uncontrolled-tab-example-tabpane-${TabsConstants.TAB_NAME_HOME}`} className="fade tab-pane active show">
													<Suspense fallback={<LoaderComponent show={true} />}><HomepageComponent /></Suspense>
												</div>
											}/>
											<Route path={ROUTE_RB_REPORT_PATH} element={
												<div id={`uncontrolled-tab-example-tabpane-${TabsConstants.TAB_NAME_RB_REPORTS}`} className="fade tab-pane active show">
													<Suspense fallback={<LoaderComponent show={true} />}><RBReportComponent /></Suspense>
												</div>
											}/>

											<Route path={ROUTE_ISE_CAL_REPORTS_PATH} element={
												<div id={`uncontrolled-tab-example-tabpane-${TabsConstants.TAB_NAME_CAL_REPORTS}`} className="fade tab-pane active show">
													<Suspense fallback={<LoaderComponent show={true} />}><ISECalibrationComponent /></Suspense>
												</div>
											}/>
										<Route path={ROUTE_CHEM_CAL_REPORTS_PATH} element={
											<div id={`uncontrolled-tab-example-tabpane-${TabsConstants.TAB_NAME_CAL_REPORTS}`} className="fade tab-pane active show">
												<Suspense fallback={<LoaderComponent show={true} />}><ChemCalReportComponent /></Suspense>
											</div>
										}/>
											<Route path="/legacy-cal-report" element={
												<div id={`uncontrolled-tab-example-tabpane-legacy-${TabsConstants.TAB_NAME_CAL_REPORTS}`} className="fade tab-pane active show">
													<Suspense fallback={<LoaderComponent show={true} />}><LegacyCalReportComponent /></Suspense>
												</div>
											}/>
											<Route path={ROUTE_PIPETTOR_MATCH_REPORT_PATH} element={
												<div id={`uncontrolled-tab-example-tabpane-${TabsConstants.TAB_NAME_PIP_REPORTS}`} className="fade tab-pane active show">
													<Suspense fallback={<LoaderComponent show={true} />}><PipettorMatchReport /></Suspense>
												</div>
											}/>
											<Route path={ROUTE_PIPETTOR_MATCH_REPORT_SIMPLE_PATH} element={
												<div id={`uncontrolled-tab-example-tabpane-${TabsConstants.TAB_NAME_PIP_REPORTS}`} className="fade tab-pane active show">
													<Suspense fallback={<LoaderComponent show={true} />}><PipettorMatchReport /></Suspense>
												</div>
											}/>
											<Route path={ROUTE_CARRYOVER_REPORT_PATH} element={
												<div id={`uncontrolled-tab-example-tabpane-${TabsConstants.TAB_NAME_CARRYOVER_REPORTS}`} className="fade tab-pane active show">
													<Suspense fallback={<LoaderComponent show={true} />}><CarryOverReport /></Suspense>
												</div>
											}/>
											<Route path={ROUTE_CARRYOVER_REPORT_SIMPLE_PATH} element={
												<div id={`uncontrolled-tab-example-tabpane-${TabsConstants.TAB_NAME_CARRYOVER_REPORTS}`} className="fade tab-pane active show">
													<Suspense fallback={<LoaderComponent show={true} />}><CarryOverReport /></Suspense>
												</div>
											}/>
											<Route path={ROUTE_LOWVOLUME_REPORT_PATH} element={
												<div id={`uncontrolled-tab-example-tabpane-${TabsConstants.TAB_NAME_LOWVOLUME_REPORT}`} className="fade tab-pane active show">
													<Suspense fallback={<LoaderComponent show={true} />}><LowVolumeReport /></Suspense>
												</div>
											}/>
											<Route path={ROUTE_LOWVOLUME_REPORT_SIMPLE_PATH} element={
												<div id={`uncontrolled-tab-example-tabpane-${TabsConstants.TAB_NAME_LOWVOLUME_REPORT}`} className="fade tab-pane active show">
													<Suspense fallback={<LoaderComponent show={true} />}><LowVolumeReport /></Suspense>
												</div>
											}/>
											<Route path={ROUTE_SYSTEM_CHECK_REPORT_PATH} element={
												<div id={`uncontrolled-tab-example-tabpane-${TabsConstants.TAB_NAME_SYSTEM_CHECK_REPORT}`} className="fade tab-pane active show">
													<Suspense fallback={<LoaderComponent show={true} />}><SystemCheckReport /></Suspense>
												</div>
											}/>
											<Route path={ROUTE_SYSTEM_CHECK_REPORT_SIMPLE_PATH} element={
												<div id={`uncontrolled-tab-example-tabpane-${TabsConstants.TAB_NAME_SYSTEM_CHECK_REPORT}`} className="fade tab-pane active show">
													<Suspense fallback={<LoaderComponent show={true} />}><SystemCheckReport /></Suspense>
												</div>
											}/>
											<Route path={ROUTE_RM_REPORT_SIMPLE_PATH} element={
												<div className="fade tab-pane active show">
													<Suspense fallback={null}><RMReport /></Suspense>
												</div>
											}/>
											<Route path={ROUTE_RM_ALL_WAVELENGTHS_SIMPLE_PATH} element={
												<div className="fade tab-pane active show">
													<Suspense fallback={null}><RMAllWavelengths /></Suspense>
												</div>
											}/>
											<Route path="*" element={<Navigate to={ROUTE_HOME} replace/>}/>
										</Routes>
									</div>
								</div>
							</div>
							<Footer versionNumber={versionNumberReducer.version} />
						</ErrorPage>
					</>}/>
				</Routes>

				<ErrorComponent heading='REQUEST ACCESS'
					message='You do not have access to the Instance Dashboard. Please contact DxS IntelliServe support team to request access'
					handleClose={() => { setShowUnAuthorized(false); window.close(); }} 
					show={showUnAuthorized}/>

			</>
		)
	}else{
		return <UnAuthorizedCompoent />
	}
};

function select(state) {
	return {
	   versionNumberReducer: state.VersionNumberReducer,
	   bannerData: state.BannerReducer,
	   featuresData: state.allowedFeaturesReducer,
	};
}
export default connect(select)(GetGlobalRouter);